// @flow strict

import * as React from 'react'
import styles from './Banner.module.scss'

const InformationIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" className={styles.icon}>
    <path
      d="M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0zm0 9a1 1 0 00-.993.883L9 10v4a1 1 0 001.993.117L11 14v-4a1 1 0 00-1-1zm0-4a1 1 0 100 2 1 1 0 000-2z"
      fill="currentColor"
    />
  </svg>
)

const Icons = Object.freeze({
  information: InformationIcon,
})

export type BannerProps = {|
  title: string,
  link: string,
  icon: $Keys<typeof Icons>,
|}

export default function Banner({ title, link, icon }: BannerProps) {
  const iconComponent = Icons[icon]

  return (
    <a href={link} className={styles.banner}>
      {iconComponent}
      {title}
    </a>
  )
}
